import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useAgreementAttachmentEnabled() {
  const feature = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.AgreementAttachments),
  )

  return feature?.enabled ?? false
}
